import { CountryFlagProps } from "./types";

const exclusionList = ["RUS", "BLR"];

const CountryFlag = ({
  region,
  width = "18px",
  height = "12px",
}: CountryFlagProps) => {
  if (exclusionList.includes(region.iso_code_long)) {
    return null;
  }

  return (
    <img
      src={`/img/flags/${region.iso_code_long}.svg`}
      alt={region.name}
      width={width}
      height={height}
    />
  );
};

export default CountryFlag;
